<template>
	<db-row width="80%" height="auto" class="dialog-confirm-wrapper" :class="confirmClass">
		<db-row class="alert-body auto-fill">
			<db-col height="auto" v-if="title" align="center" class="dialog-title">{{title}}</db-col>
			<db-col class="dialog-message auto-fill" valign="middle" align="center">
				{{message}}
			</db-col>
		</db-row>
		<db-col height="auto" align="center">
			<db-button type="info" height="80" plain class="auto-fill" around @click="cancelHandler">取消</db-button>
			<db-col width="24" />
			<db-button class="auto-fill" height="80" around @click="confirmHandler">{{confirmText}}</db-button>
		</db-col>
	</db-row>
</template>

<script>
	import {Alert} from '../../../../model/Dialog'
	
	export default {
		props: {
			title: {
				type: [String, Number],
				default: ''
			},
			
			message: {
				type: [String, Number],
				default: ''
			},
			
			confirm: {
				type: Function
			},
			
			cancel: {
				type: Function
			},
			
			confirmText: {
				type: String,
				default: '确定'
			}
		},
		
		data(){
			return {
				confirmClass: 'confirm-init'
			}
		},
		
		mounted(){
			this.start()
		},
		
		methods: {
			async start(){
				return new Promise(res => {
					setTimeout(() => {
						this.confirmClass = 'confirm-active'
						setTimeout(async () => {
							res()
						}, 200)
					}, 50)
				})
			},
			
			async close(){
				return new Promise(res => {
					this.confirmClass = 'confirm-init'
					setTimeout(() => {
						this.$store.commit('mobileStore/removeDialog')
						res()
					}, 300)
				})
			},
			
			async confirmHandler(){
				await this.close()
				if(this.confirm){
					this.confirm()
				}
			},
			
			async cancelHandler(){
				await this.close()
				if(this.cancel){
					this.cancel()
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.dialog-confirm-wrapper{
		padding: 30px 40px;
		color: #333;
		background: rgba(#fff, 1.0);
		border-radius: 64px;
		transition: all .15s;
		min-height: 400px;
		
		&.confirm-init{
			opacity: 0;
			transform: scale(.8);
		}
		&.confirm-active{
			opacity: 1.0;
			transform: scale(1.0);
		}
		
		.dialog-title{
			color: #333;
			font-weight: bold;
			font-size: 32px;
		}
		
		.confirm-body{
			padding-bottom: 30px;
			
			.dialog-message{
				color: #333;
				padding: 0 30px;
				line-height: 42px;
				font-size: 32px;
				text-align: center;
			}
		}
	}
</style>